export default __webpack_public_path__ + "static/media/business-ahs-icon-4.ad4219b2.png";